module.exports = __webpack_public_path__ + "img/slider_banner_3.2b53de1a.jpg";